export default __webpack_public_path__ + "static/1161-bbfe413a36e1cd0d6f57e8ec6fb09abb.gif";